import { COLORS, LBTButtonFilter, LBTSelect } from '@laborability/components';
import {
  ANALYTIC_METRIC_LABEL,
  COMPARISION_PERIOD,
  DateAggregationEnum,
  PERIOD,
  TABS,
  viewTypeEnum,
} from './types';
import {
  AnalyticMetricEnum,
  AnalyticMetricRecord,
  companiesState,
  currentUserState,
  UserRole,
} from '@laborability/commons';
import { useRecoilValue } from 'recoil';

interface Props {
  range: number;
  setRange: (range: number) => void;
  comparisonRange: number | null;
  setComparisonRange: (range: number | null) => void;
  companyId: number | null;
  setCompanyId: (companyId: number | null) => void;
  tabId: number;
  setTabId: (companyId: number) => void;
  currentMetric: AnalyticMetricEnum;
  setCurrentMetric: (range: AnalyticMetricEnum) => void;
  currentTab: {
    id: number;
    label: string;
    metrics: AnalyticMetricEnum[];
  };
  dateAggregation: DateAggregationEnum;
  setDateAggregation: (dateAggregation: DateAggregationEnum) => void;
  currentView: {
    id: number;
    label: string;
    type: viewTypeEnum;
  };
}

export const Filter = ({
  range,
  setRange,
  comparisonRange,
  setComparisonRange,
  companyId,
  setCompanyId,
  currentMetric,
  setCurrentMetric,
  currentTab,
  dateAggregation,
  setDateAggregation,
  currentView,
  tabId,
  setTabId,
}: Props) => {
  const currentUser = useRecoilValue(currentUserState);
  const companies = useRecoilValue(companiesState);
  const filteredPeriod = PERIOD.filter(value =>
    value.isVisible.includes(dateAggregation),
  );
  const filteredComparisionPeriod = COMPARISION_PERIOD.filter(value =>
    value.isVisible.includes(dateAggregation),
  );
  return (
    <div
      style={{
        backgroundColor: COLORS.getInstance().BW_GREYS_IPERLIGHT,
        width: '30%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '20px',
        gap: '20px',
        height: 'fit-content',
      }}
    >
      <h2
        style={{
          marginBottom: '10px',
          height: '50px',
          display: 'flex',
          alignItems: 'end',
          fontSize: '16px',
        }}
      >
        Filtri
      </h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        {TABS.map(tab => (
          <LBTButtonFilter
            key={tab.id}
            isSelected={tab.id === tabId}
            isGrey
            onClick={() => {
              setTabId(tab.id);
              setCurrentMetric(
                TABS.find(item => item.id === tab.id)?.metrics.find(
                  metric => AnalyticMetricRecord[metric].timeSeries,
                )!,
              );
            }}
          >
            {tab.label}
          </LBTButtonFilter>
        ))}
      </div>
      <LBTSelect
        label="Range"
        value={range}
        items={filteredPeriod.map(period => ({
          id: period.id,
          name: period.label,
        }))}
        handleChange={value => setRange(value)}
        required
      />
      <LBTSelect
        label="Range di Confronto"
        value={comparisonRange}
        items={filteredComparisionPeriod.map(period => ({
          id: period.id,
          name: period.label,
        }))}
        handleChange={value => setComparisonRange(value)}
      />
      {currentView.type === viewTypeEnum.timeseries && (
        <>
          <LBTSelect
            label="Metrica"
            value={currentMetric}
            items={currentTab.metrics
              .filter(metric => AnalyticMetricRecord[metric].timeSeries)
              .map(metric => ({
                id: metric,
                name: ANALYTIC_METRIC_LABEL[metric],
              }))}
            handleChange={value => setCurrentMetric(value)}
            required
          />
          <LBTSelect
            label="Aggregazione per periodo"
            value={dateAggregation}
            items={[
              {
                id: DateAggregationEnum.day,
                name: 'Giornaliero',
              },
              {
                id: DateAggregationEnum.week,
                name: 'Settimanale',
              },
              {
                id: DateAggregationEnum.month,
                name: 'Mensile',
              },
            ]}
            handleChange={value => setDateAggregation(value)}
            required
          />
        </>
      )}

      {currentUser.role === UserRole.ADMIN && (
        <LBTSelect
          id="company_id-select"
          name="company_id"
          label="Seleziona azienda"
          value={companyId}
          items={companies.map(item => ({
            id: item.id as number,
            name: `${item.name} - ${item.vat_number}`,
          }))}
          handleChange={value => setCompanyId(value)}
        />
      )}
    </div>
  );
};
